import { range } from '@/utils'
import { PAGE_WIDTH } from './PageCard'
import { PlaceholderSheet } from './PlaceholderSheet'

// About a screen's worth of pages, so the pane looks like the strip it is waiting for.
const SHEET_COUNT = 8

// A card keeps this much room round its sheet, so a stand-in sheet is this much narrower.
const CARD_INSET = 8

export const LoadingPages = () => (
  <div data-loading-pages className="flex flex-col gap-2 p-3">
    <div className="flex gap-1">
      {range(SHEET_COUNT).map((sheet) => (
        <PlaceholderSheet
          key={`sheet-${sheet}`}
          width={PAGE_WIDTH - CARD_INSET}
          loading
        />
      ))}
    </div>
    {/* The sheets already spin, so the line beside them is text and nothing else. */}
    <p className="text-xs text-ink-subtle">Loading the pages…</p>
  </div>
)
